import { FOOTER_FETCHED } from "../types";

const initialState = {loaded:false};

export default function footer(state = initialState,  action) {
  switch (action.type) {
      case FOOTER_FETCHED:
        return Object.assign({}, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/footer.js